import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { EmailService } from "src/app/services/email.service";
import { Title } from "@angular/platform-browser";

@Component({
    selector: 'app-component-nope-receive-email',
    templateUrl: './nope-receive-email.component.html',
    styleUrls: ['./nope-receive-email.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NopeReceiveEmailComponent implements OnInit, AfterContentChecked {
    isMobile = window.innerWidth < 1000 ? true : false;
    id: string;
    now: Date;
    hour: number;
    minute: number;
    date: string;

    constructor(
        private router: Router,
        private emailService: EmailService,
        private titleService: Title,
        private activeRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef) {
        this.titleService.setTitle("Xác nhận email từ khách hàng");
    }

    ngOnInit() {
        this.now = new Date;
        this.hour = this.now.getHours();
        this.minute = this.now.getMinutes();
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    goToDefaultPage() {
        this.router.navigate(["/"]);
    }

    nopeReceiveEmail() {
        this.emailService.nopeReceiveEmail(this.id).subscribe(
            res => {
                if (res.isRedirect) {
                    this.router.navigate([res.redirectUrl], { queryParams: { _id: res.id } });
                }
            },
            error => {
                console.log(error);
            }
        )
    }
}